import React, { Component } from 'react'
import { number, shape, string, func, arrayOf } from 'prop-types'
// import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { debounce } from 'lodash'

import './Register.scss'

import { TextField, SelectField, TypeableSelectField } from '../Fields'
import { doRegister, getCity } from '../../modules/User'
import { changePopup } from '../../modules/Main'

class Register extends Component {
  state = {
    fields: {
      name: '',
      phone: '',
      email: '',
      password: '',
      cpassword: '',
      slug: '',
      city: '',
      sex: '',
    },
    error: {},
  }

  componentDidMount() {
    this.props.getCity(10, '')
  }

  onChangeValidate = (name, values) => {
    const err = this.validate(name, values)
    if (err !== null) {
      this.setState({
        error: ({ ...this.state.error, ...{ [`${name}`]: err } }),
      })
    } else {
      const error = this.state.error
      delete error[`${name}`]
      this.setState({
        error,
      })
    }
  }

  handleOnFieldFocus = (e) => {
    const error = this.state.error
    if (error[`${e.target.name}`]) {
      delete error[`${e.target.name}`]
    }
    this.setState({
      error,
    })
  }

  handleOnFieldBlur = (e) => {
    this.onChangeValidate(e.target.name, e.target.value)
  }

  handleOnFieldChange = (e) => {
    const { name, value } = e.target
    let slug = this.state.fields.slug

    if (name === 'name') {
      slug = `${value.split(' ').join('-').toLowerCase()}-${Math.floor(Math.random() * 100000)}`
    }

    this.setState({
      fields: ({ ...this.state.fields, [name]: value, slug }),
    }, () => {
      this.onChangeValidate(name, value)
    })
  }

  handleTypeableInputChange = (value) => {
    this.debounced(10, value)
  }

  debounced = debounce((limit, vals) => {
    this.props.getCity(limit, vals)
  }, 500)

  validate = (fields, values) => {
    let err = null

    if (fields === 'name') {
      if (values === '') {
        err = 'Nama tidak boleh kosong'
      }
    }
    if (fields === 'phone') {
      if (values === '') {
        err = 'Handphone tidak boleh kosong'
      }
    }
    if (fields === 'email') {
      if (values === '') {
        err = 'Email tidak boleh kosong'
      }
      if (!values.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        err = 'Email tidak sesuai format'
      }
    }

    if (fields === 'password') {
      if (values === '') {
        err = 'Password tidak boleh kosong'
      }

      if (values.length < 4) {
        err = 'Password minimal 4 karakter'
      }

      if (this.state.fields.cpassword !== '' && this.state.fields.cpassword !== values) {
        err = 'Password dan Konfirmasi Password tidak sesuai'
      }
    }

    if (fields === 'cpassword') {
      if (values === '') {
        err = 'Konfirmasi Password tidak boleh kosong'
      }

      if (values.length < 4) {
        err = 'Konfirmasi Password minimal 4 karakter'
      }

      if (this.state.fields.password !== '' && this.state.fields.password !== values) {
        err = 'Password dan Konfirmasi Password tidak sesuai'
      }
    }

    if (fields === 'sex') {
      if (values === '') {
        err = 'Gender tidak boleh kosong'
      }
    }

    return err
  }

  handleRegister = () => {
    if (Object.keys(this.state.error).length === 0 && this.state.error.constructor === Object) {
      const tifOptions = Object.keys(this.state.fields).map((key) => {
        const err = this.validate(key, this.state.fields[`${key}`])
        if (err !== null) {
          this.setState({
            error: ({ ...this.state.error, ...{ [`${key}`]: err } }),
          })
          return false
        }
        return true
      })

      const filtered = tifOptions.filter(x => x === false)
      if (filtered.length === 0) {
        const phoneFirst = Number(this.state.fields.phone.substr(0, 1))
        let phoneRight = this.state.fields.phone

        if (phoneFirst === 0) {
          phoneRight = `62${this.state.fields.phone.substr(1, this.state.fields.phone.length)}`
        }

        const variables = {
          name: this.state.fields.name,
          email: this.state.fields.email,
          password: this.state.fields.password,
          phone: phoneRight,
          city: this.state.fields.city,
          slug: this.state.fields.slug,
          sex: this.state.fields.sex,
        }

        this.props.doRegister(variables)

        this.clearState()
      }
    }
  }

  clearState = () => {
    this.setState({
      fields: {
        name: '',
        email: '',
        password: '',
        phone: '',
        slug: '',
        city: '',
        sex: '',
      },
      error: {},
    })
  }

  render() {
    const { user, city, getCityRequest } = this.props
    const gender = [
      {
        id: '',
        name: 'Select Gender',
      },
      {
        id: 'Male',
        name: 'Male',
      },
      {
        id: 'Female',
        name: 'Female',
      },
    ]
    return (
      <div className='login__wrapper clearfix'>
        <h2>Bergabung Sekarang</h2>
        { user.errorRegister !== '' && <div className='alert alert-danger'>{user.errorRegister}</div>}
        { user.successRegister !== '' && <div className='alert alert-success'>
          {user.successRegister}, Silahkan login <a onClick={() => { this.props.changePopup('login') }}>disini</a>
        </div>}
        <div className='login__form noBor'>
          <div className='row'>
            <div className='rl-cl-l-6'>
              <TextField
                label={'Nama'}
                name={'name'}
                type={'text'}
                error={this.state.error.name}
                handleOnFieldFocus={this.handleOnFieldFocus}
                handleOnFieldChange={this.handleOnFieldChange}
                handleOnFieldBlur={this.handleOnFieldBlur}
                value={this.state.fields.name}
                tabIndex={0} />
            </div>
            <div className='rl-cl-l-6'>
              <TextField
                label={'Nomor Handphone'}
                name={'phone'}
                type={'number'}
                error={this.state.error.phone}
                handleOnFieldFocus={this.handleOnFieldFocus}
                handleOnFieldChange={this.handleOnFieldChange}
                handleOnFieldBlur={this.handleOnFieldBlur}
                value={this.state.fields.phone}
                tabIndex={0} />
            </div>
          </div>
          <TextField
            label={'Email'}
            name={'email'}
            type={'eamil'}
            error={this.state.error.email}
            handleOnFieldFocus={this.handleOnFieldFocus}
            handleOnFieldChange={this.handleOnFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            value={this.state.fields.email}
            tabIndex={0} />

          <div className='row'>
            <div className='rl-cl-xs-6 rl-cl-l-6'>
              <TextField
                label={'Password'}
                name={'password'}
                type={'password'}
                error={this.state.error.password}
                handleOnFieldFocus={this.handleOnFieldFocus}
                handleOnFieldChange={this.handleOnFieldChange}
                handleOnFieldBlur={this.handleOnFieldBlur}
                value={this.state.fields.password}
                tabIndex={0} />
            </div>
            <div className='rl-cl-xs-6 rl-cl-l-6'>
              <TextField
                label={'Konfirmasi Password'}
                name={'cpassword'}
                type={'password'}
                error={this.state.error.cpassword}
                handleOnFieldFocus={this.handleOnFieldFocus}
                handleOnFieldChange={this.handleOnFieldChange}
                handleOnFieldBlur={this.handleOnFieldBlur}
                value={this.state.fields.cpassword}
                tabIndex={0} />
            </div>
          </div>
          <div className='row'>
            <div className='rl-cl-xs-6 rl-cl-l-6'>
              <TypeableSelectField
                selectData={city}
                placeholder={'Pilih kota...'}
                name={'city'}
                error={this.state.error.city}
                handleOnFieldChange={this.handleOnFieldChange}
                handleOnFieldFocus={this.handleOnFieldFocus}
                handleOnFieldBlur={this.handleOnFieldBlur}
                handleInputChange={this.handleTypeableInputChange}
                value={this.state.fields.city}
                isLoading={getCityRequest}
                tabIndex={0} />
            </div>
            <div className='rl-cl-xs-6 rl-cl-l-6'>
              <SelectField
                selectData={gender}
                name={'sex'}
                type={'text'}
                error={this.state.error.sex}
                handleOnFieldFocus={this.handleOnFieldFocus}
                handleOnFieldChange={this.handleOnFieldChange}
                handleOnFieldBlur={this.handleOnFieldBlur}
                value={this.state.fields.sex}
                tabIndex={0} />
            </div>
          </div>
          {/* <Link to='/' className='sms__login' tabIndex='-1'>Masuk dengan nomor telfon</Link> */}
          <div className='row'>
            <div className='rl-cl-l-12'>
              <p className='register__tnc'>Dengan menekan tombol di bawah, Anda telah menyetujui <a href='/'>
              Kebijakan Privasi</a> dan <a href='/'>Syarat & Ketentuan</a> Minapoli.</p>
            </div>
          </div>
          <button
            type='button'
            className='login__button'
            onClick={this.handleRegister}
            disabled={user.registerRequest ? 'disabled' : ''}>Daftar</button>
        </div>
      </div>
    )
  }
}

Register.defaultProps = {
  user: {},
  city: [],
}

Register.propTypes = {
  user: shape({
    errorRegister: string,
    successRegister: string,
  }),
  city: arrayOf(shape({
    id: number,
    name: string,
  })),
  doRegister: func.isRequired,
  changePopup: func.isRequired,
  getCity: func.isRequired,
}

const mapStateToProps = state => ({
  user: state.user,
  city: state.user.city,
  getCityRequest: state.user.getCityRequest,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  doRegister,
  changePopup,
  getCity,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Register)



// WEBPACK FOOTER //
// ./src/common/Auth/Register.js